/// <amd-module name="Wit/UI/DataProviders/index" />
export { IWorkItemTrackingDataProvider } from "./IWorkItemTrackingDataProvider";
export * from "./WorkItemTrackingDataProvider";
